import { useState } from 'react';
import {
  CreateRecordingProps,
  Recording,
  RecordingId,
  UpdateRecordingProps,
  FileEntity,
  FileId,
  MusicalRelease,
} from '@solo/app-core';
import { translate } from '@/app/i18n';
import { Button, Flex, Text } from '@/app/ui/atoms';
import { RecordingTableComponent, RecordingForm } from '@/app/ui/organisms';

interface MusicalReleaseRecordingsFormProps {
  recordings: Recording[];
  // type: string;
  showNavButtons?: (show: boolean) => void;
  removeRecording: (recordingId: RecordingId) => void;
  getAudioInfo: (audioId: FileId) => Promise<FileEntity>;
  createRecording: (recording: CreateRecordingProps) => Promise<void>;
  updateRecording: (recording: UpdateRecordingProps, recordingId: RecordingId) => Promise<void>;
  reorderRecordings: (recordingId: RecordingId, indexTo: number) => void;
  setNewAudio: (audio: File) => void;
  closeForm?: () => void;
  musicalRelease?: MusicalRelease;
}

const MusicalReleaseRecordingsForm = (props: MusicalReleaseRecordingsFormProps) => {
  const {
    recordings,
    // type,
    showNavButtons,
    removeRecording,
    getAudioInfo,
    createRecording,
    updateRecording,
    reorderRecordings,
    closeForm,
    setNewAudio,
    musicalRelease,
  } = props;
  const [addingNewTrack, setAddingNewTrack] = useState<boolean>(false);
  const [notEditableRecordingsIds, setNotEditableRecordingsIds] = useState<RecordingId[]>([]);

  const title = translate('WORKS_PAGES.ADD_RELEASE_TRACKS');
  // switch (type) {
  //   case 'ALBUM':
  //     title = translate('WORKS_PAGES.ADD_ALBUM_TRACKS');
  //     break;
  //   case 'SINGLE':
  //     title = translate('WORKS_PAGES.ADD_SINGLE_TRACKS');
  //     break;
  //   default:
  //     title = translate('WORKS_PAGES.ADD_EP_TRACKS');
  // }

  function deleteTrack(track: Recording) {
    removeRecording(track.id);
    setNotEditableRecordingsIds(
      notEditableRecordingsIds.filter((recordingId) => recordingId !== track.id),
    );
  }

  return (
    <Flex.Container flexDirection="column" gap="4rem" style={{ width: '100%' }}>
      {addingNewTrack ? (
        <RecordingForm
          getAudioInfo={(audioId) => getAudioInfo(audioId)}
          createRecording={(recording) => createRecording(recording)}
          updateRecording={(recording, recordingId) => updateRecording(recording, recordingId)}
          musicalRelease={musicalRelease}
          closeForm={() => {
            setAddingNewTrack(false);
            if (showNavButtons) showNavButtons(true);
          }}
          setNewAudio={(audioFile) => setNewAudio(audioFile)}
        />
      ) : (
        <Flex.Container flexDirection="column" gap="25px">
          <Flex.Container gap="25px" flexDirection="column">
            <Text.SubtitleBold>{title}</Text.SubtitleBold>
            <Text.LabelMedium>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. At nec cras mauris, blandit
              in id non tellus. Tincidunt quis facilisi fermentum at eu.us
            </Text.LabelMedium>
          </Flex.Container>
          <Flex.Container gap="16px" style={{ width: '100%' }} alignItems="flex-end">
            <Flex.Container flex={2}>
              <Button
                $size="sm"
                $variant="reversed"
                $transparent
                $outline
                style={{ height: '38px', width: '160px' }}
                onClick={() => {
                  setAddingNewTrack(true);
                  // eslint-disable-next-line no-console
                  if (showNavButtons !== undefined) showNavButtons(false);
                }}
              >
                <Text.SectionSubtitle style={{ padding: 0 }} fontWeight={600}>
                  {translate('BUTTON.ADD_NEW_TRACK')}
                </Text.SectionSubtitle>
              </Button>
            </Flex.Container>
          </Flex.Container>
          {recordings && recordings?.length > 0 && (
            <RecordingTableComponent
              key={recordings.map((r) => r.id).toString()}
              changeOrder={reorderRecordings}
              getAudioInfo={(audioId) => getAudioInfo(audioId)}
              createRecording={(recording) => createRecording(recording)}
              updateRecording={(recording, recordingId) => updateRecording(recording, recordingId)}
              recordings={recordings}
              notEditableRecordingsIds={notEditableRecordingsIds}
              deleteRecording={(track: Recording) => deleteTrack(track)}
              setNewAudio={(audio) => setNewAudio(audio)}
            />
          )}
          {closeForm && (
            <Flex.Container style={{ marginLeft: 'auto' }} gap="20px">
              <Button
                $transparent
                $variant="primary"
                onClick={() => {
                  closeForm();
                }}
              >
                <Text.SectionSubtitle>{translate('PROFILE_INFO.CANCEL')}</Text.SectionSubtitle>
              </Button>

              <Button
                $size="md"
                $variant="primary"
                style={{ width: '290px' }}
                onClick={() => {
                  closeForm();
                }}
              >
                <Text.SectionSubtitle style={{ padding: 0 }} fontWeight={600}>
                  {translate('PROFILE_INFO.SAVE')}
                </Text.SectionSubtitle>
              </Button>
            </Flex.Container>
          )}
        </Flex.Container>
      )}
    </Flex.Container>
  );
};

export default MusicalReleaseRecordingsForm;
